@if (achievement) {
  <div class="achievement-card" [class.not-achieved]="!achievement.achieved && !progress" (click)="openModal()">
    @if (achievement.achieved || (!achievement.achieved && !progress)) {
      <div class="achievement-card__icon">
        <lib-icon [icon]="achievement.achieved ? 'check' : 'lock-simple'" size="16"></lib-icon>
      </div>
    }
    <div class="achievement-card__image">
      <img
        [placeholderImage]="!achievement.mediaImage && achievement.bundle"
        [cropImage]="achievement.mediaImage | preSignedUrl | async"
        [additionalOptions]="{width: 150, height: 150, func: 'bound'}"
        alt="achievement">
    </div>
    <div class="achievement-card__title">
      {{achievement.title}}
    </div>
    @if (achievement.achievementType === AchievementTypeEnum.QUANTITIVE) {
      <div class="achievement-card__progress">
        <mat-progress-bar class="default-theme" mode="determinate" [value]="progress"></mat-progress-bar> {{achievement.numberOfCompletedContents}}/{{achievement.numberOfContents}}
      </div>
    }
    @if (coupon) {
      <div class="achievement-card__coupon">
        <lib-icon icon="ticket" size="20"></lib-icon>
        <div class="achievement-card__coupon--body">
          {{coupon.couponTitle}}
        </div>
      </div>
    }
  </div>
}
